import { render, staticRenderFns } from "./TemplateConsoleLayout.vue?vue&type=template&id=5bb9c7b9&scoped=true&"
import script from "./TemplateConsoleLayout.vue?vue&type=script&lang=js&"
export * from "./TemplateConsoleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb9c7b9",
  null
  
)

export default component.exports